import styled from "styled-components";

export default styled.div`
  .tab__commerce {
    background-color: transparent;
    box-shadow: none;
    border-bottom: 1px solid #ddd;

    .commerce__tab--button {
      color: rgba(0, 0, 0, 0.6);
      &.Mui-selected {
        color: ${(props) => props.theme.colors.primary.main}
      }
    }
  }

  .advertising {
    margin-top: 10px;
    p {
      color: rgba(0, 0, 0, 0.87);
    }

    .ads__usage {
      font-size: 12px;
    }
    .ads__requirements {
      font-size: 16px;
      line-height: 28px;
      letter-spacing: 0.48px;
    }
  }

  .custom-package {
    position: relative;
    width: 100%;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.87);
    letter-spacing: 0.48px;
    font-weight: 400;
  }

  .divider {
    margin-top: 30px;
  }

  .contact--us {
    button {
      width: 150px;
      height: 36px;
      margin-bottom: 10px;
      color: ${(props) => props.theme.colors.primary.main};
      border: 1px solid rgba(0, 0, 0, 0.12);
      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }
    }

    &.advertising {
      button {
        width: 310px;
      }
    }
  }

  @media screen and (max-width: 991px) {
    #history-licenses,
    #history-purchase,
    .MuiTabs-indicator {
      width: 120px;
    }

    .custom-package {
      font-size: 12px;
      margin-top: 5px;
      margin-bottom: 10px;
    }

    .contact--us {
      &.advertising {
        button {
          color: white;
          font-size: 12px;
        }
      }
    }
  }
`;
